import React from 'react';
import AudienceWorkInfo from './audiences/work/AudienceWorkInfo';
import MainContent from './layout/MainContent';
import { ICON_INFO, ICON_SCHEDULING, ICON_NOTIFICATION, ICON_TREATMENT, ICON_VIDEO } from './extras/icons';
import { useParams, useHistory } from 'react-router';
import AudienceScheduling from './audiences/work/AudienceScheduling';
import AudienceNotifications from './audiences/work/AudienceNotifications';
import AudienceTreatment from './audiences/work/AudienceTreatment';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { getAudiencesAction } from '../actions/audiencesActions';
import { useEffect } from 'react';
import { SOLICITUD, APROBADA, AGENDADA, CANCELADA, REPROGRAMADA, SUSPENDIDA } from '../data/audienceStates';
import { LABEL_RESERVED } from './extras/labels';
import { VIDEOS_AUDIENCIAS_VER } from '../data/objects';

import Authorities from '../services/AuthoritiesService';
//Función principal
const AudienceWork = () => {
    //Tomo los parametros
    const { id, component } = useParams();
    //Tomo el history
    const history = useHistory();
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Tomo el store
    const audience = useSelector(state => state.audiences.audienceWork);
    const loading = useSelector(state => state.audiences.audienceLoading);
    const authUser = useSelector(state => state.auth.user);
    const authorities = useSelector(state => state.auth.authorities);
    //Tomo los datos al inicio
    useEffect(() => {
        //Tienen q haber datos de usuario
        if(authUser){
            //Busco datos de audiencia
            dispatch( getAudiencesAction(id, authUser) );
        }
    }, [id, authUser]);
    //Nodos
    const nodes = [];
    //Acciones
    let actions = [
        {
            icon: <ICON_INFO />,
            text: 'DATOS SOLICITUD',
            link: `/audiencias/${id}/formulario-trabajo/informacion`,
            css: 'warning',
            granted: true
        }
    ];
    //Agrego las acciones dinámicamente
    if(audience){
        //Aprobada
        if(audience.estado && audience.estado.id > SOLICITUD && audience.estado.id <= CANCELADA){
            //Agrego agendamiento
            actions = [
                ...actions,
                {
                    icon: <ICON_SCHEDULING />,
                    text: 'AGENDAMIENTO',
                    link: `/audiencias/${id}/formulario-trabajo/agendamiento`,
                    css: 'warning',
                    granted: true
                }
            ];
        }
        //Agendada
        if(audience.estado && audience.estado.id >= AGENDADA && audience.estado.id <= CANCELADA){
            //Agrego restantes
            actions = [
                ...actions,
                {
                    icon: <ICON_NOTIFICATION />,
                    text: 'NOTIFICACIONES',
                    link: `/audiencias/${id}/formulario-trabajo/notificaciones`,
                    css: 'warning',
                    granted: true
                },
                {
                    icon: <ICON_TREATMENT />,
                    text: 'TRATAMIENTO',
                    link: `/audiencias/${id}/formulario-trabajo/tratamiento`,
                    css: 'warning',
                    granted: true
                }
            ];
            if(audience.estado.id <= SUSPENDIDA){
                //Verifico si agrego videos
                if(authorities && Authorities.hasPermission(authorities, VIDEOS_AUDIENCIAS_VER)){
                    //Agrego enlace a videos
                    actions = [
                        ...actions,
                        {
                            icon: <ICON_VIDEO />,
                            text: 'VIDEOS',
                            link: `/audiencias/${id}/videos`,
                            css: 'warning',
                            granted: true,
                            newTab: true
                        }
                    ];
                }
            }
        }
    }
    //Manejo la selección del component
    const handleComponent = () => {
        switch (component) {
            case 'informacion':
                return <AudienceWorkInfo />;
            case 'agendamiento':
                //Me fijo que deba estar APROBADA
                if(audience && audience.estado.id < APROBADA){
                    history.push(`/audiencias/${id}/formulario-trabajo/informacion`);
                }
                return <AudienceScheduling />;
            case 'notificaciones':
                //Me fijo que deba estar AGENDADA
                if(audience && audience.estado.id < AGENDADA){
                    history.push(`/audiencias/${id}/formulario-trabajo/informacion`);
                }
                return <AudienceNotifications />;
            case 'tratamiento':
                //Me fijo que deba estar AGENDADA
                if(audience && audience.estado.id < AGENDADA){
                    history.push(`/audiencias/${id}/formulario-trabajo/informacion`);
                }
                return <AudienceTreatment />;
        }
    }
    //Renderizo
    return (
        <MainContent 
            title={`Audiencia #${id}`}
            subtitle={ audience && audience.estado ? audience.estado.descripcion : '' } 
            showSubtitle={true}
            cssSubtitle={`text-${audience && audience.estado ? audience.estado.css : 'gray'}`}
            nodes={nodes}
            actions={actions}
            component={ handleComponent }
            extraItem={ audience && audience.privada === 1 ? <LABEL_RESERVED className="ml-2" /> : null }
        />
    );
};

export default AudienceWork;